export const PERIPHERAL_BRIDGE_CALL_METHODS = {
  CANCEL_TRANSACTION_ATTEMPT: 'cancelTransactionAttempt',
  EXECUTE_TERMINAL_REQUEST: 'executeTerminalRequest',
  ON_SYNC_NETWORK_DATA: 'onSyncNetworkData', // Summit and later
  EXECUTE_SALE_REQUEST: 'executeSaleRequest',
  CONNECT_DEVICE: 'connectDevice',
  START_SCANNER: 'startScanner',
  STOP_SCANNER: 'stopScanner',
  PERFORM_MAINTENANCE: 'performMaintenance',
  DEVICE_SUBTYPE: 'deviceSubtype',
  GET_NETWORK_STATUS_INFO: 'getNetworkStatusInfo',
  OPEN_DRAWER: 'openDrawer',
}

export const PERIPHERAL_BRIDGE_CALL_HANDLER_METHODS = {
  GET_DEVICE_IDENTIFIERS: 'getDeviceIdentifiers',
  GET_SERIAL_NUMBER: 'getSerialNumber',
  CHECK_STATUS: 'checkStatus',
  EXECUTE_TERMINAL_REQUEST: 'executeTerminalRequest',
  GET_BUILD_INFO: 'getBuildInfo',
  GET_CONFIG: 'getConfig',
  GET_SAF_MODE: 'getSafMode',
  HANDLE_SAF_OFFLINE_PROMPT: 'handleSafOfflinePrompt',
  PRINT_RECEIPT: 'printReceipt',
  REPLAY_REQUEST: 'replayRequests',
  SAVE_CONFIG: 'saveConfig',
}

export const PERIPHERAL_BRIDGE_REGISTER_HANDLER_METHODS = {
  CANCEL_TRANSACTION: 'cancelTransaction',
  ERROR_TRANSACTION: 'errorTransaction',
  FIRMWARE_VERSION: 'firmwareVersion',
  HANDLE_RESULT: 'handleResult',
  HANDLE_SAF_MODE: 'handleSafMode',
  HANDLE_SAF_RESULT: 'handleSAFResult',
  HANDLE_TERMINAL_INFO: 'handleTerminalInfo',
  LANE_ATTACHED: 'laneAttached',
  LANE_CLOSED: 'laneClosed',
  LANE_OPENED: 'laneOpened',
  LANE_REMOVED: 'laneRemoved',
  PRINTER_CONNECTION_STATE: 'printerConnectionState',
  REPLAY_AUTH_STATUS: 'replayAuthStatus',
  SCAN_ERROR: 'scanError',
  SCAN_PAYLOAD: 'scanPayload',
  VOID_TRANSACTION: 'voidTransaction',
}
